// import axios from "axios";
// import CryptoJS from "crypto-js";
// import { BASE_URL } from "./BaseURL";
// import { mapBackendMessage } from "../screen/notification/BackendMessage";

// const SECRET_KEY = "843567893696976453275974432697R634976";

// const authInstance = axios.create({
//   baseURL: BASE_URL,
//   headers: { "Content-Type": "application/json" },
// });

// // authInstance.interceptors.request.use(
// //   (config) => {
// //     // Skip the interceptor for login API
// //     if (config.url.includes("/login")) {
// //       return config;
// //     }

// //     const encryptedAccessToken = localStorage.getItem("accessToken");

// //     if (encryptedAccessToken) {
// //       const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, SECRET_KEY);
// //       const decryptedAccessToken = bytes.toString(CryptoJS.enc.Utf8);

// //       if (decryptedAccessToken) {
// //         config.headers["Authorization"] = `Bearer ${decryptedAccessToken}`;
// //       } else {
// //         console.error("Failed to decrypt the token.");
// //       }
// //     } else {
// //       console.error("No access token found in localStorage.");
// //     }

// //     return config;
// //   },
// //   (error) => {
// //     return Promise.reject(error);
// //   }
// // );

// authInstance.interceptors.request.use(
//   (config) => {
//     const encryptedAccessToken = localStorage.getItem("accessToken");

//     if (encryptedAccessToken) {
//       const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, SECRET_KEY);
//       const decryptedAccessToken = bytes.toString(CryptoJS.enc.Utf8);

//       if (decryptedAccessToken) {
//         config.headers["Authorization"] = `Bearer ${decryptedAccessToken}`;
//       } else {
//         // console.error("Failed to decrypt the token.");
//       }
//     } else {
//       // console.error("No access token found in localStorage.");
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

// authInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response) {
//       const { status, data } = error.response;
//       if (status === 401) {
//         localStorage.removeItem("accessToken");
//         localStorage.removeItem("refreshToken");
//         delete authInstance.defaults.headers.common["Authorization"];
//       }

//       const backendMessage =
//         data?.message || "An unknown error occurred. Please try again.";
//       const customMessage = mapBackendMessage(backendMessage);

//       error.customMessage = customMessage;

//       return Promise.reject(error);
//     }

//     return Promise.reject(error);
//   }
// );

// export default authInstance;

import axios from "axios";
import CryptoJS from "crypto-js";
// import { RefreshTokenEffect } from "./auth/AuthEffect";
import { BASE_URL } from "./BaseURL";
import { mapBackendMessage } from "../screen/notification/BackendMessage";
import { store } from "./store";
import { refreshTokenRequest, resetRefreshTokenState } from "./auth/AuthAction";

const SECRET_KEY = "843567893696976453275974432697R634976";

const authInstance = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

const TOKEN_REFRESH_INTERVAL = 115 * 1000;
let tokenRefreshTimer = null;

function startTokenRefreshTimer() {
  if (tokenRefreshTimer) clearInterval(tokenRefreshTimer);

  tokenRefreshTimer = setInterval(async () => {
    if (!tokenRefreshPromise) {
      try {
        await handleTokenRefresh();
      } catch (error) {
        console.error("Automatic token refresh failed:", error);
        stopTokenRefreshTimer();
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        window.location.href = "/";
      }
    } else {
      console.log("Timer: Token refresh already in progress...");
    }
  }, TOKEN_REFRESH_INTERVAL);
}

function stopTokenRefreshTimer() {
  if (tokenRefreshTimer) {
    clearInterval(tokenRefreshTimer);
    tokenRefreshTimer = null;
  }
}

let tokenRefreshPromise = null;

async function handleTokenRefresh() {
  if (!tokenRefreshPromise) {
    const encryptedRefreshToken = localStorage.getItem("refreshToken");
    if (!encryptedRefreshToken) return Promise.reject("No refresh token found");

    const bytes = CryptoJS.AES.decrypt(encryptedRefreshToken, SECRET_KEY);
    const decryptedRefreshToken = bytes.toString(CryptoJS.enc.Utf8);

    tokenRefreshPromise = new Promise((resolve, reject) => {
      const unsubscribe = store.subscribe(() => {
        const state = store.getState();
        const refreshState = state.auth.refreshToken;

        if (refreshState?.success) {
          unsubscribe();

          const { accessToken, refreshToken } = refreshState;

          // Encrypt tokens again before saving
          const encryptedAccess = CryptoJS.AES.encrypt(
            accessToken,
            SECRET_KEY
          ).toString();
          const encryptedRefresh = CryptoJS.AES.encrypt(
            refreshToken,
            SECRET_KEY
          ).toString();

          localStorage.setItem("accessToken", encryptedAccess);
          localStorage.setItem("refreshToken", encryptedRefresh);

          tokenRefreshPromise = null;
          resolve(accessToken);
        }

        if (refreshState?.error) {
          unsubscribe();
          tokenRefreshPromise = null;
          reject(
            new Error(refreshState.errormessage || "Refresh token failed")
          );
        }
      });

      // Dispatch the redux action that triggers saga API call
      store.dispatch(resetRefreshTokenState());
      store.dispatch(refreshTokenRequest({ token: decryptedRefreshToken }));
    });
  }

  return tokenRefreshPromise;
}

// Request interceptor — attach token
authInstance.interceptors.request.use(
  (config) => {
    const encryptedAccessToken = localStorage.getItem("accessToken");
    if (encryptedAccessToken) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, SECRET_KEY);
        const decryptedAccessToken = bytes.toString(CryptoJS.enc.Utf8);
        if (decryptedAccessToken) {
          config.headers["Authorization"] = `Bearer ${decryptedAccessToken}`;
        }
      } catch (e) {
        console.error("Failed to decrypt access token", e);
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

// Response interceptor
authInstance.interceptors.response.use(
  (response) => {
    // Start the refresh timer
    if (!tokenRefreshTimer) startTokenRefreshTimer();
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    if (error.response) {
      const { status, data } = error.response;

      if (status === 401) {
        // Unauthorized - clear tokens, stop refresh, redirect login
        localStorage.removeItem("accessToken");
        localStorage.removeItem("refreshToken");
        stopTokenRefreshTimer();
        delete authInstance.defaults.headers.common["Authorization"];
        window.location.href = "/";
        return Promise.reject(error);
      }

      if (status === 403 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({
              resolve: (token) => {
                originalRequest.headers["Authorization"] = `Bearer ${token}`;
                resolve(authInstance(originalRequest));
              },
              reject: (err) => reject(err),
            });
          });
        }

        originalRequest._retry = true;
        isRefreshing = true;

        try {
          const newAccessToken = await handleTokenRefresh();

          const encryptedAccess = CryptoJS.AES.encrypt(
            newAccessToken,
            SECRET_KEY
          ).toString();
          localStorage.setItem("accessToken", encryptedAccess);

          processQueue(null, newAccessToken);

          originalRequest.headers["Authorization"] = `Bearer ${newAccessToken}`;
          return authInstance(originalRequest);
        } catch (refreshError) {
          processQueue(refreshError, null);
          localStorage.removeItem("accessToken");
          localStorage.removeItem("refreshToken");
          stopTokenRefreshTimer();
          window.location.href = "/";
          return Promise.reject(refreshError);
        } finally {
          isRefreshing = false;
        }
      }

      // Map backend error messages
      const backendMessage =
        data?.message || "An unknown error occurred. Please try again.";
      error.customMessage = mapBackendMessage(backendMessage);
    }

    return Promise.reject(error);
  }
);

export { startTokenRefreshTimer, stopTokenRefreshTimer };
export default authInstance;
